import {
    Avatar,
    Breadcrumb,
    BreadcrumbItem,
    Button,
    Carousel,
    CarouselItem,
    Checkbox,
    Divider,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Input,
    Loading,
    Pagination,
    Table,
    TableColumn,
} from 'element-ui'

import Vue from 'vue'

Vue.use(Button)
Vue.use(Input)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Avatar)
Vue.use(Pagination)
Vue.use(Divider)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Checkbox)
Vue.use(Loading.directive)